import React from 'react'

import Checkbox from '../Fields/Checkbox'

const ModuleSeven = (props) => {
	return (
		<div>
			<h3>INFORMATION FOR FEMALE PATIENTS</h3>
			<Checkbox 
				controlFunc={props.addToForm}
				name={"femaleConsent"}
				value={props.consentForm.femaleConsent}
			/>
			I have informed my doctor about my use of birth control pills. I have been advised that certain antibiotics and other medications may neutralize the preventive effect of birth control pills, allowing for conception and pregnancy. I agree to consult with my personal physician to initiate additional forms of birth control during the period of my treatment, and to continue those methods until advised by my personal physician that I can return to the use of oral birth control pills.	
		</div>
	)
}

export default ModuleSeven


// WEBPACK FOOTER //
// ./src/components/Modules/7.js